













































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { MediaObject, MediaUpload } from '@/modules/media/types'
import { State, Mutation, Action, Getter } from 'vuex-class'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {notify} from '@/modules/core/notification';

export enum MediaDetailMode {
    None = 'none',
    // Modifica los detalles de un archivo que se va a subir al servidor
    Upload = 'upload',
    // Modifica los detalles de un archivo que se ha registrado
    Edit = 'edit',
}

/**
 * Información sobre el archivo
 *
 * Muestra la información sobre el archivo y permtite editarla
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class MediaDetail extends Vue {

    @Prop({required: true})
    public mode: MediaDetailMode

    @State(state => state.media.currentMedia)
    public currentMedia: MediaObject

    @State(state => state.media.hasSelectedMedia)
    public hasSelectedMedia: boolean

    @State(state => state.media.hasSelectedUpload)
    public hasSelectedUpload: boolean

    @Mutation('media/objects/field/update')
    public updateMediaObjectField: (payload: {id: number, field: string, value: any}) => void

    @Mutation('media/object/current/field/update')
    public updateCurrentMediaObjectField: (payload: { field: string, value: any}) => void

    @Mutation('media/mediaUpload/field/update')
    public updateMediaUploadField: (payload: {id: string, field: string, value: any}) => void

    @Action('media/object/delete')
    public deleteMediaObject: (payload: {media: MediaObject, closeViewer: boolean}) => void

    @Getter('media/object')
    public getMediaObject: (id: number) => MediaObject | undefined

    @Getter('media/upload/current')
    public currentUpload: MediaUpload

    @Action('media/object/update')
    public updateMediaObject: (media: MediaObject) => void

    public deleting = false
    public updating = false
    public valid = true

    public rules = {
        title: [ (v: string) => v.length <= 100 || 'El título no puede contener mas de 100 caracteres' ],
        // tslint:disable-next-line:max-line-length
        key: [ (v: string) => /^[a-z0-9\_\-\.]+$/i.test(v) || 'La clave solo puede contener numeros, letras, puntos y guiones'],
    }

    get loading (): boolean {
        return this.deleting || this.updating
    }

    /**
     * Objeto multimedia
     *
     * Retorna el objeto multimedia actualmente en edición, dependiendo del modo
     * de edición será un objeto multimedia ya registrado o un perteneciente
     * a una subida.
     */
    get media (): MediaObject {
        const modes: KeyValuePair = {
            [MediaDetailMode.Edit]: () => this.currentMedia,
            [MediaDetailMode.Upload]: () => this.currentUpload.media,
        }

        return modes[this.mode]() || new MediaObject()
    }

    /**
     * Comprueba si hay algún objeto multimedia u objeto de subida seleccionado
     * según el modo de edición
     */
    get hasSelection (): boolean {
        if (this.mode === MediaDetailMode.None) {
            return false
        }

        return this.isUpload ? this.hasSelectedUpload : this.hasSelectedMedia
    }

    /**
     * Actualiza un campo de un objeto multimedia en el estado de la aplicación
     */
    public update (field: string, value: string) {
        switch (this.mode) {
            case MediaDetailMode.Edit:
                return this.updateCurrentMediaObjectField({ field, value })
            case MediaDetailMode.Upload:
                return this.updateMediaUploadField({id: this.currentUpload.id, field: `media.${field}`, value})
            default:
                throw new Error(`El modo "${this.mode}" no es válido`)
        }
    }

    get isUpload (): boolean {
        return this.mode === MediaDetailMode.Upload
    }

    get validForUpdate (): boolean {
        if (this.isUpload) {
            return true
        }

        const media = this.getMediaObject(this.media.id)
        if (!media) {
            return false
        }

        return !MediaObject.contentIsEqual(media, this.media)
    }

    /**
     * Elimina el archivo multimedia actual
     */
    public async deleteMedia (media: MediaObject) {
        this.deleting = true
        await this.deleteMediaObject({media, closeViewer: true})

        // Termino el proceso
        this.deleting = false
    }

    public async edit () {
        this.updating = true
        await this.updateMediaObject(this.media)

        this.updating = false
    }

    /**
     * Método lanzado cuando el usuario coloca el foco sobre el input que
     * contiene en enlace del archivo.
     *
     * Copia la URL al portapapeles
     *
     * @param event
     */
    public onFocusURL (event: FocusEvent) {
        const target = event.target as HTMLInputElement
        if (!target) {
            return
        }

        target.select()
        document.execCommand('copy')

        notify('La URL del archivo ha sido copiada al portapapeles')
    }
}
